'use strict';

import 'angular';


export default function($log, $parse, $interpolate, $http, $uibModal, toastr, Upload) {
	'ngInject';

	return {
		require: 'form',
		link: {
			pre: preLink,
			post: postLink,
		},
	};

	// Other rest directives makes use of these objects in postLink, thus we
	// define them in the preLink to make sure they're always defined.
	function preLink(scope, element, attrs, $form) {
		$form.$rest = {
			$data: {},
			$errors: {},
		};
	}

	function postLink(scope, element, attrs, $form) {
		if (attrs.action === undefined) {
			throw 'brg-rest-form requires an action';
		}

		if (attrs.method === undefined) {
			attrs.method = 'POST';
		}

		var fields = [];
		angular.forEach(element.find('input'), function(input) {
			fields.push(input.name);
		});

		var instance = scope.$eval(attrs.instance);
		const shouldFetchInstance = attrs.fetchInstance === undefined ? true : scope.$eval(attrs.fetchInstance);
		var confirmModal;
		if (attrs.confirm) {
			confirmModal = $interpolate(attrs.confirm)(scope);
		}

		if (confirmModal) {
			element.on('submit', confirmSubmit);
		} else if (attrs.simpleConfirm) {
			element.on('submit', simpleConfirmSubmit);
		} else {
			element.on('submit', submit);
		}

		if (instance) {
			if (attrs.method == 'PATCH') {
				$form.$rest.$data = mergeFields({}, instance, fields);
			} else {
				$form.$rest.$data = instance;
			}
		} else if (shouldFetchInstance && ['DELETE', 'PATCH', 'PUT'].indexOf(attrs.method) > -1) {
			$log.debug('Retrieving instance');
			element.addClass('retrieving');
			$http.get(attrs.action).then(retrieveSuccess, retrieveError).finally(retrieveFinally);
		}

		function retrieveSuccess(response) {
			if (attrs.method == 'PATCH') {
				$form.$rest.$data = mergeFields({}, response.data, fields);
			} else {
				$form.$rest.$data = response.data;
			}
		}

		function retrieveError(e) {
			$log.error(e);
			element.addClass('disabled');
			$form.$rest.$errors = {
				disabled: `An error occurred retrieving the data [${e.status}].`
			};
		}

		function retrieveFinally() {
			element.removeClass('retrieving');
		}

		function confirmSubmit(event) {
			var modalOptions = {
				template: confirm,
			};
			$uibModal.open(modalOptions).result.then(submit.bind(null, event));
		}

		function simpleConfirmSubmit(event) {
			event.preventDefault();
			if (confirm(attrs.simpleConfirm)) {
				submit(event);
			}
		}

        function _performSubmit() {
            const submitData = {
                url: attrs.action,
                method: attrs.method,
                data: $form.$rest.$data,
            }
            if (attrs.fileUpload) {
                return Upload.upload(submitData);
            } else {
                return $http(submitData);
            }
        }

		function submit(event) {
			event.preventDefault();
			// Clear the errors
			Object.keys($form.$rest.$errors).forEach(function(prop) {
			  delete $form.$rest.$errors[prop];
			  });
			$form.$rest.$submitting = true;
			element.addClass('submitting');
            _performSubmit().then(submitSuccess, submitError).finally(submitFinally);
		}

		function submitSuccess(response) {
			if (attrs.checkResponse && !$parse(attrs.checkResponse)(scope, {$response: response})) {
				console.error('Response check failed!');
				console.log(response);
				if (attrs.errorMessage) {
					console.log(attrs.errorMessage);
					toastr.error($interpolate(attrs.errorMessage)({$error: response}));
				}
				$parse(attrs.onError)(scope, {$error: response});
				return;
			}
			if (instance) {
				angular.merge(instance, response.data)
			}
			if (attrs.successMessage) {
				toastr.success(attrs.successMessage);
			}
			$parse(attrs.onSuccess)(scope, {$response: response});
		}

		function submitError(e) {
			$log.error(e);
			angular.forEach(e.data, function(value, field) {
				if (!Array.isArray(value)) {
					e.data[field] = [value];
				}
			});
			angular.merge($form.$rest.$errors, e.data);
			if (attrs.errorMessage) {
				toastr.error($interpolate(attrs.errorMessage)({$error: e}));
			}
			$parse(attrs.onError)(scope, {$error: e});
		}

		function submitFinally() {
			element.removeClass('submitting');
			$form.$rest.$submitting = false;
		}
	}
}


function mergeFields(dest, src, fields) {
	fields.forEach(function(field) {
		dest[field] = src[field];
	});
	return dest;
}
